module.exports = ".card{margin-bottom:0 !important}\n"